var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: " my-10" }, [
    _c(
      "div",
      { staticClass: "bg-white overflow-hidden shadow rounded-lg mt-10" },
      [
        _vm._m(0),
        _vm._m(1),
        !_vm.shouldShowExtensionLink
          ? _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                _c(
                  "div",
                  { staticClass: "sm:flex sm:items-start sm:justify-between" },
                  [
                    _vm._m(2),
                    _c(
                      "div",
                      {
                        staticClass:
                          "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "inline-flex rounded-md shadow-sm" },
                          [
                            _vm.store.plan === "limited_free"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                                    attrs: { type: "button" },
                                    on: { click: _vm.gotoPlans }
                                  },
                                  [_vm._v(" Upgrade now ")]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm.shouldShowExtensionLink
          ? _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
              _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                _c(
                  "div",
                  { staticClass: "sm:flex sm:items-start sm:justify-between" },
                  [
                    _vm._m(3),
                    _c(
                      "div",
                      {
                        staticClass:
                          "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "inline-flex rounded-md shadow-sm" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "Polaris-Button Polaris-Button--primary",
                                attrs: { type: "button" },
                                on: { click: _vm.openDownload }
                              },
                              [_vm._m(4)]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ]
    ),
    _vm.shouldShowExtensionLink
      ? _c("div", { staticClass: "bg-white shadow sm:rounded-lg mt-4" }, [
          _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
            _c("div", {}, [
              _c("div", [
                _c(
                  "h3",
                  {
                    staticClass: "text-lg leading-6 font-medium text-gray-900"
                  },
                  [_vm._v(" Chat Extension API Key ")]
                ),
                _c("div", [
                  _c(
                    "label",
                    {
                      staticClass:
                        "block text-sm font-medium leading-6 text-gray-900",
                      attrs: { for: "comment" }
                    },
                    [_vm._v("API Key")]
                  ),
                  _c("div", { staticClass: "mt-2" }, [
                    _c("textarea", {
                      staticClass:
                        "block w-full rounded-md  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:py-1.5 sm:text-sm sm:leading-6 border",
                      attrs: { rows: "4", name: "comment", id: "comment" },
                      domProps: { value: _vm.apiKey }
                    })
                  ])
                ])
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                },
                [
                  _c(
                    "span",
                    { staticClass: "inline-flex rounded-md shadow-sm" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                          attrs: { type: "button" },
                          on: { click: _vm.copyAPIKey }
                        },
                        [_vm._v(" Copy ")]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "border-b border-gray-200 px-4 py-5 sm:px-6" },
      [_c("h1", [_vm._v("Contextual chat extension")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
      _c("div", { staticClass: "mt-2 mb-6 text-sm leading-5 text-gray-500" }, [
        _vm._v(
          " When you are chatting with your customers in WhatsApp you will get contextual information about the customer on the right side. You don't have to go search their order details. You can answer the exact queries with the relevant order information about the customer. "
        )
      ]),
      _c("img", { attrs: { src: require("../../assets/contextextn.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Upgrade to use this feature ")
      ]),
      _c(
        "div",
        { staticClass: "mt-2 max-w-xl text-sm leading-5 text-gray-500" },
        [_c("p")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Download Chrome Extension ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [
        _vm._v("Add to chrome")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }